import { render, staticRenderFns } from "./Articles.vue?vue&type=template&id=a5844774&scoped=true&"
import script from "./Articles.vue?vue&type=script&lang=js&"
export * from "./Articles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5844774",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ArticleCard: require('/home/lewis/actions-runner/_work/EchoWaveLunar/EchoWaveLunar/components/global/ArticleCard.vue').default})
